import Axios from "../../axios";
import { ApiResponse } from "../../apiResponse";

// @param candidateData: object
// example:
// {
//   "full_name": "Rizaq Hummos"
// }
export function updateTutor(tutorData: object): Promise<ApiResponse> {
  return Axios.put(`v1/tutors/tutors`, tutorData);
}
export function getTutor(): Promise<ApiResponse> {
  return Axios.get(`v1/tutors/tutors`);
}
